import { Injectable } from '@angular/core';
import { RestService } from '../../../services/rest.service';
import { RestResponse } from '../../../interface/RestInterface';
import { CollectionRequest } from '../interface/collection-request.interface';
import { Share } from '../../share';
import { CreateCollectionRequestDto } from '../dto/create-collection-request.dto';
import { PaginatedResponse } from '@qid/core';

@Injectable({
  providedIn: 'root',
})
export class CollectionRequestService {
  static readonly ApiEndpoint = 'collection-request/';

  constructor(private restService: RestService) { }

  async read(id: string): Promise<RestResponse<unknown>> {
    return this.restService.send<unknown>({
      url: CollectionRequestService.ApiEndpoint + id,
      method: 'GET',
    });
  }

  async readAll(): Promise<RestResponse<PaginatedResponse<CollectionRequest>>> {
    return this.restService.send<PaginatedResponse<CollectionRequest>>({
      url: CollectionRequestService.ApiEndpoint,
      method: 'GET',
    });

  }

  async readOne<T>(id: string): Promise<RestResponse<CollectionRequest>> {
    return this.restService.send<CollectionRequest>({
      url: CollectionRequestService.ApiEndpoint + id,
      method: 'GET',
    });
  }


  async create(body: CreateCollectionRequestDto): Promise<RestResponse<CollectionRequest>> {
    return this.restService.send<CollectionRequest>({
      url: CollectionRequestService.ApiEndpoint,
      method: 'POST',
      body,
    });
  }

  async update<T>(id: string, body: T): Promise<RestResponse<T>> {
    return this.restService.send<T>({
      url: CollectionRequestService.ApiEndpoint + id,
      method: 'PUT',
      body,
    });
  }

  async delete(id: string): Promise<RestResponse<unknown>> {
    return this.restService.send<unknown>({
      url: CollectionRequestService.ApiEndpoint + id,
      method: 'DELETE',
    });
  }

  async execute(id: string): Promise<RestResponse<CollectionRequest>> {
    return this.restService.send<CollectionRequest>({
      url: CollectionRequestService.ApiEndpoint + 'execute/' + id,
      method: 'POST',
    });
  }
}
